/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2021, Zumper
 */

export const getOptimizelyExperimentsOrigin = (variationMap?: {
  [title: string]: string | null | undefined
}) => {
  const experiments = []

  if (variationMap) {
    for (const [experiment, variation] of Object.entries(variationMap)) {
      if (variation && variation !== 'ORIGINAL') {
        experiments.push(`${experiment}:${variation}`)
      } else if (variation === 'ORIGINAL') {
        experiments.push(`${experiment}:ORIGINAL`)
      }
    }
  }
  if (experiments.length) {
    return `EXP=[${experiments.join(',')}]`
  }
  return ''
}
